import React from 'react'
import { ApplicationPropertiesContext } from "../../../../common/context/ApplicationPropertiesProvider";
import GetCompensationContextProvider, {
    ACTIONS,
    GetCompensationContext,
} from "../../context/GetCompensationContextProvider";
import Loading from "../../../../common/components/Loading";
import { CGE } from '../../../../common/components/CGE';
import { useModal } from "@clayui/modal";
import { TOKEN_CAPTCHA_COOKIE_KEY } from "../../../../common/utils/cookiesUtil";
import useCookie from '../../../../common/hooks/useCookie';


const GetCompensationPublic = ({ options, titleCompensation, textFetchError, descripcioneCompensationPublic,
    textAlertFilledField, loading, setLoading, setGlobalAlert, toggleCurrentComponent }) => {
    const properties = React.useContext(ApplicationPropertiesContext);
    const [state, dispatch] = React.useContext(GetCompensationContext);
    const [verifReCaptcha, setVerifReCaptcha] = React.useState(false);
    const [yearSelected, setYearSelected] = React.useState('');
    const [numberClient, setNumberClient] = React.useState('');
    const [emptyError, setEmptyError] = React.useState(false);
    const [visibleModal, setVisibleModal] = React.useState(false);
    const { observer, onClose } = useModal({
        onClose: () => {
            setVisibleModal(false);
        },
    });
    const { updateCookieState } = useCookie(TOKEN_CAPTCHA_COOKIE_KEY);


    let propsLabelInfoContent = {
        "content": state?.webContentTextInfo,
        "observer": observer,
        "onClose": onClose,
        "setVisibleModal": setVisibleModal,
        "status": "info",
        "titleModal": "Información",
        "visibleModal": visibleModal,
        "titleHint": "Ayuda Nro de Cliente",
    }

    React.useEffect(() => {
        if(toggleCurrentComponent === '2'){
            dispatch({
                payload: toggleCurrentComponent,
                type: ACTIONS.SET_TAG,
            });

        }
    }, [toggleCurrentComponent]);


    function onChangeReCaptcha(value) {
        updateCookieState(value);
        if (value) {
            setVerifReCaptcha(true);
            if (numberClient && yearSelected && !verifReCaptcha) {
                setEmptyError(false)
            } else {
                setEmptyError(true)
            }
        }
        else {
            setVerifReCaptcha(false);

        }
    }

    function handleChangeYearSelected(e) {
        setYearSelected(e.target.value);
    }

    function handleChangeNumberCliente(e) {
        setNumberClient(e.target.value);
    }

    function handleClickButton() {
        if (numberClient && yearSelected && verifReCaptcha) {
            setLoading(true)
            setEmptyError(false)
            dispatch({
                payload: [numberClient, yearSelected],
                type: ACTIONS.SET_CURRENT_ARRAY,
            })
        } else {
            setLoading(false)
            setEmptyError(true)
            if(!numberClient && !yearSelected && !verifReCaptcha){
                setGlobalAlert(textAlertFilledField, "warning");
            } else if(numberClient && yearSelected && !verifReCaptcha){
                setGlobalAlert("Falta validar que no eres un Robot.", "warning");

            }
            dispatch({
                payload: [],
                type: ACTIONS.SET_CURRENT_ARRAY,
            })
        }
    }

    React.useEffect(() => {
        if (numberClient && yearSelected && verifReCaptcha) {
            setEmptyError(false)
        }
    }, [numberClient || yearSelected])

    React.useEffect(() => {
        setEmptyError(false)
    }, [])

    React.useEffect(() => {
        if (state.responseCompensation || state.errorFetch !== null) {
            setLoading(false);
        }
    }, [state.responseCompensation, state.errorFetch]);

    React.useEffect(() => {

        if (state.responseCompensation?.status === 500) {
            setGlobalAlert(textFetchError, "warning", true, "Advertencia");
        } else if (state.responseCompensation?.message) {
            setGlobalAlert(state.responseCompensation?.message, "warning", true, "Advertencia");
        }

    }, [state.responseCompensation]);

    return (
        <div id="container-get-compensation-public" >
            <div>
                <CGE.Panel title={titleCompensation} description={descripcioneCompensationPublic}>
                    <CGE.PanelContainer
                        alingItensCenter={true}
                        size="md"
                    >
                        <CGE.FormsField
                            horizontal={true}
                            labelName="Nro. de Cliente: "
                            handleChange={handleChangeNumberCliente}
                            idFormElement="numberClientId"
                            mandatoryElement={true}
                            msgError={!numberClient && emptyError && "Debes ingresar un Nro. de Cliente."}
                            typeFormElement="text"
                            typeElement="input-mask"
                            maxLength="12"
                            formatChars={{
                                9: "[0-9]"
                            }}
                            mask="999999999999"
                            hasError={!numberClient && emptyError ? true : false}
                            value={numberClient}
                            propsLabelInfoContent={propsLabelInfoContent}
                        />
                        <CGE.FormsField
                            hasError={!yearSelected && emptyError}
                            msgError={"Debes seleccionar un año."}
                            horizontal={true}
                            labelName="Año: "
                            handleChange={handleChangeYearSelected}
                            idFormElement="anoSelect"
                            typeFormElement="text"
                            mandatoryElement={true}
                            typeElement="select"
                            listOptions={options}
                        />
                    </CGE.PanelContainer>
                    <div className="d-flex divClayFormMobile align-items-center flex-column">
                        <CGE.PanelContainer
                            alingItensCenter={true}
                            size="md"
                        >
                            <CGE.FieldRecaptcha
                                horizontal={true}
                                onChange={onChangeReCaptcha}
                                sitekey={properties.api_key_recaptcha}
                            />
                        </CGE.PanelContainer>
                        <CGE.Button
                            label="Generar Cartola"
                            onClick={() => handleClickButton()}
                            type="primary"
                        />
                    </div>
                </CGE.Panel>
            </div>
            {loading && <Loading />}
        </div >
    )
}

const GetCompensationPublicWithProvider = ({
    titleCompensation,
    description,
    options,
    textFetchError,
    descripcioneCompensationPublic,
    textAlertFilledField,
    loading,
    setLoading,
    setGlobalAlert,
    toggleCurrentComponent
}) => (
    <GetCompensationContextProvider>
        <GetCompensationPublic
            titleCompensation={titleCompensation}
            description={description}
            descripcioneCompensationPublic={descripcioneCompensationPublic}
            options={options}
            textFetchError={textFetchError}
            textAlertFilledField={textAlertFilledField}
            loading={loading}
            setLoading={setLoading}
            setGlobalAlert={setGlobalAlert}
            toggleCurrentComponent={toggleCurrentComponent}
        />
    </GetCompensationContextProvider>
);
export default GetCompensationPublicWithProvider;